import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import Placeholder from '@/components/Placeholder';
import { TABLET_L } from '@/constants';
import media from '../styles/media.style';
import { MOBILE_PADDING, PAGE_WIDTH, SCREEN_LOCKUP_HEIGHT, SCREEN_LOCKUP_WIDTH } from '../styles/variables.style';

const Outer = styled.section`
  background: ${({ background }) => background};
  max-height: ${({ locked }) => (locked ? `${SCREEN_LOCKUP_HEIGHT}` : 'none')};
  padding: ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    padding: ${({ desktopPadding }) => desktopPadding || '40px 0'};
  `};
`;

const Inner = styled.div`
  background: ${({ background }) => background};
  margin: auto;
  max-height: inherit;
  max-width: ${({ locked }) => (locked ? `${PAGE_WIDTH}px` : '100%')};
  width: 100%;
`;

const PlaceholderWrapper = styled.div`
  text-align: center;
`;

const Content = Inner.extend`
  max-width: ${({ locked }) => (locked ? `${SCREEN_LOCKUP_WIDTH}px` : '100%')};
`;

const Section = ({ children, id, options }) => (
  <React.Fragment>
    {!(options && children) ? (
      <PlaceholderWrapper>
        <Placeholder w={window.innerWidth > TABLET_L ? '100%' : '335px'} h={window.innerWidth > TABLET_L ? '55px' : '90px'} />
      </PlaceholderWrapper>
    ) : (
      <Outer {...options.outer} id={id}>
        <Inner {...options.inner}>
          <Content {...options.content}>{children}</Content>
        </Inner>
      </Outer>
    )}
  </React.Fragment>
);

Section.defaultProps = {
  children: null,
  id: '',
  options: {
    outer: {
      background: undefined,
      locked: false,
    },
    inner: {
      background: undefined,
      locked: false,
    },
    content: {
      background: undefined,
      locked: false,
    },
  },
};

Section.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  id: PropTypes.string,
  options: PropTypes.shape({
    outer: PropTypes.shape(),
    inner: PropTypes.shape(),
    content: PropTypes.shape(),
  }),
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section.js